import InfoBadgePill from "core/components/badge/infoBadgePill";
import { KursusoverviewFilterModel } from "../models/KursusoverviewModel";
import { Localizer } from "infrastructure/localization/localizer";

type KursusOverviewDisplayAppliedFiltersProps = {
  filter: KursusoverviewFilterModel;
  containerClasses?: string;
}
const KursusOverviewDisplayAppliedFilters = ({ 
  filter, 
  containerClasses 
}: KursusOverviewDisplayAppliedFiltersProps) => {
  
  const displaySpecialer = filter.specialeIds && filter.specialeIds.length > 0;
  const displayUddannelser = filter.uddannelseIds && filter.uddannelseIds.length > 0;
  const displayRegioner = filter.regionIds && filter.regionIds.length > 0;
  const displayKursusGrupper = filter.kursusgrupper && filter.kursusgrupper.length > 0;


  const renderFilterItemBadge = (label: string, count: number) => {
    if (count === 0) return;

    const value = `${count} ${count === 1 ? Localizer.valgt() : Localizer.global_valgte()}`;

    return (
      <InfoBadgePill
          badgeText={<><b>{label}:</b> {value}</>}
          paddingSize='padding-s'
          badgeType='badge-info-light'
      />
    )
  }

  return (
     <div className={containerClasses}>
        {displaySpecialer && renderFilterItemBadge(Localizer.global_specialer(), filter.specialeIds?.length ?? 0)}
        {displayUddannelser && renderFilterItemBadge(Localizer.global_uddannelser(), filter.uddannelseIds?.length ?? 0)}
        {displayRegioner && renderFilterItemBadge(Localizer.global_regioner(), filter.regionIds?.length ?? 0)}
        {displayKursusGrupper && renderFilterItemBadge(Localizer.global_kursusGrupper(), filter.kursusgrupper?.length ?? 0)}
      </div>
  )
}

export default KursusOverviewDisplayAppliedFilters;
